const { createSlice } = require('@reduxjs/toolkit');
const collectionProductSlice = createSlice({
    name: 'collectionProduct',
    initialState: {
        products: [],
    },
    reducers: {
        setCollectionProducts(state, action) {
            state.products = action.payload;
        }
    },
});
export const { setCollectionProducts } = collectionProductSlice.actions;
export default collectionProductSlice.reducer;